module.exports = __webpack_public_path__ + "media/images/farey/index/trouver_un_successeur_pour_mon_cabinet-22a2702a37e915e871a03375923e5f16.png";